import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState, useCallback } from 'react';
/**
 * Use a callback style ref behavior, as outlined here:
 * https://reactjs.org/docs/refs-and-the-dom.html#callback-refs
 *
 * This allows us to rerender our components when
 * nodes are first mounted (compared to traditional refs
 * which don't cause rerenders).
 *
 * @example:
 * ```jsx
 * const [el, setEl] = useCallbackRef();
 *
 * useEffect(() => {
 *  if (el) {
 *    console.log('My div has mounted')
 *  }
 * }, [el])
 *
 * return (
 *  <div ref={setEl} />
 * )
 * ```
 */

export function useCallbackRef(defaultState) {
  var _useState = useState(defaultState),
      _useState2 = _slicedToArray(_useState, 2),
      el = _useState2[0],
      setEl = _useState2[1];

  var callback = useCallback(function (node) {
    setEl(node);
  }, []);
  return [el, callback];
}